import React from "react";

// Images
import logo from "../images/ic_logo.svg";

import styled from "styled-components";
import { breakpoints } from "../utils/size";

export const TermsWrapper = styled.div`
  background: ${(props) => props.theme.black};
  padding: 40px 0px;

  @media only screen and (${breakpoints.mobile}) {
    padding: 40px 20px;
  }

  img {
    display: flex;
    margin: auto;
  }
`;

export const TermContent = styled.div`
  width: 877px;
  margin: 40px auto;

  @media only screen and (${breakpoints.mobile}) {
    width: 100%;
  }

  h1 {
    opacity: 1;
    color: ${(props) => props.theme.white};
    font-family: "SpaceGrotesk";
    font-size: 36px;
    font-weight: 500;
    font-style: Medium;
    letter-spacing: 0px;
    text-align: left;
    line-height: 50px;

    @media only screen and (${breakpoints.mobile}) {
      font-size: 32px;
      line-height: 46px;
    }
  }

  h2 {
    opacity: 1;
    color: ${(props) => props.theme.white};
    font-family: "SpaceGrotesk";
    font-size: 20px;
    font-weight: 500;
    font-style: Medium;
    letter-spacing: 0px;
    text-align: left;
    line-height: 30px;
    margin: 40px 0 4px;

    @media only screen and (${breakpoints.mobile}) {
      font-size: 18px;
      line-height: 28px;
    }
  }

  h3 {
    opacity: 1;
    color: ${(props) => props.theme.blueish};
    font-family: "SatoshiRegular";
    font-size: 20px;
    font-weight: 400;
    font-style: Regular;
    letter-spacing: 0px;
    text-align: left;
    line-height: 28px;

    @media only screen and (${breakpoints.mobile}) {
      font-size: 18px;
      line-height: 26px;
    }
  }

  p {
    opacity: 1;
    color: ${(props) => props.theme.blueish};
    font-family: "SatoshiRegular";
    font-size: 16px;
    font-weight: 400;
    font-style: Regular;
    letter-spacing: 0px;
    text-align: left;
    line-height: 24px;

    @media only screen and (${breakpoints.mobile}) {
      font-size: 16px;
      line-height: 24px;
    }

    a {
      font-family: "SatoshiRegular";
      color: ${(props) => props.theme.green};
    }
  }
`;


const Terms = () => {
  return (
    <TermsWrapper>
      <a href="/">
        <img src={logo} alt={logo} />
      </a>
      <TermContent>
        <h1>Smrt Stats Terms of Service</h1>
        <h3>
          Welcome to Smrt Stats. These Terms of Service apply to the Smrt Stats website located at www.smrtstats.com, its main domain and all subdomains, and all associated applications and services, including StatsConnect, owned by Smrt Football Limited and its affiliates (collectively, the "Smrt Stats Platform"). Smrt Football Limited ("Smrt Stats", "we", "our", or "us") provides the Smrt Stats Platform to you subject to the following terms of use ("Terms"). By visiting the Smrt Stats Platform, you accept these Terms. Please read them carefully. Additional terms apply to some services, including the <a href="/connect/terms">StatsConnect Terms</a> at https://smrtstats.com/connect/terms.
        </h3>

        <h2>1. PRIVACY</h2>
        <p>
          Please review Smrt Stats' Privacy Policy, which also governs your visit to the Smrt Stats Platform, to understand Smrt Stats' practices with respect to your personal information.
        </p>

        <h2>2. ELECTRONIC COMMUNICATIONS</h2>
        <p>
          When you visit the Smrt Stats Platform or send emails, feedback, or messages to Smrt Stats, you are communicating with Smrt Stats electronically. You consent to receive communications from Smrt Stats electronically. Smrt Stats will communicate with you by email or by posting notices on the Smrt Stats Platform. You agree that all agreements, notices, disclosures, and other communications that we provide to you electronically satisfy any legal requirement that such communications be in writing. Any feedback you provide will be deemed non-confidential. Smrt Stats will be free to use such feedback on an unrestricted basis.
        </p>

        <h2>3. SMRT STATS INTELLECTUAL PROPERTY</h2>
        <p>
          The Smrt Stats Platform and all content included on the Platform, such as text, graphics, logos, button icons, images, video clips, statistical data compilations, and software, (together, "Smrt Stats Intellectual Property") are the property of Smrt Stats or its content providers and is protected by Irish, European Union and international copyright, trademark, patent, trade secret and other intellectual property laws. Smrt Stats, the Smrt Stats logo, and all related names, logos, product and service names, designs, and slogans are trademarks of Smrt Stats, registered under the Irish Register of Trademarks (Trade Mark No. 2023/01150) and protected under European Union and international copyright, trademark, patent, trade secret and other intellectual property laws, and may not be used without Smrt Stats' prior written permission.
        </p>

        <h2>4. LICENSE AND PLATFORM ACCESS</h2>
        <h3>4.1. Limited License</h3>
        <p>
          Smrt Stats grants you a limited licence to access and use the Smrt Stats Platform for the purposes permitted by your plan or agreement with Smrt Stats. This licence does not include resale or redistribution of the Platform or its contents, or any use of data mining, robots, crawlers or similar data gathering and extraction tools, except the access methods Smrt Stats provides for this purpose (such as its API, data downloads and the StatsConnect connector for AI assistants) and only within the limits of your plan.
        </p>

        <h3>4.2. Prohibited Uses</h3>
        <p>
          The Smrt Stats Platform or any portion of the Platform may not be reproduced, duplicated, copied, sold, resold, visited, or otherwise exploited for any commercial purpose without express written consent of Smrt Stats. You may not frame or utilize framing techniques to enclose any trademark, logo, or other proprietary information of Smrt Stats without express written consent. You may not use any meta tags or any other "hidden text" utilizing Smrt Stats' name or trademarks without express written consent. Use within the scope of a paid plan or written agreement with Smrt Stats, including StatsConnect Agent and Club plans, counts as consent for this clause.
        </p>

        <h3>4.3. Platform Availability</h3>
        <p>
          Smrt Stats reserves the right to withdraw or amend the Smrt Stats Platform, and any service or material we provide on the Platform, in Smrt Stats' sole discretion without notice. Smrt Stats will not be liable if for any reason all or any part of the Platform is unavailable at any time or for any period.
        </p>

        <h3>4.4. Termination of Rights</h3>
        <p>
          If you breach these Terms, your right to use the Smrt Stats Platform will stop immediately and you must, at Smrt Stats' option, return or destroy any copies of the materials you have made. No right, title, or interest in or to the Platform or any content on the Platform is transferred to you, and all rights not expressly granted are reserved by Smrt Stats.
        </p>

        <h2>5. ACCEPTABLE USE POLICY</h2>
        <p>
          By accessing the Smrt Stats Platform, you agree to:
          <br />• Use the Platform only for lawful purposes
          <br />• Not attempt to gain unauthorized access to any systems or data
          <br />• Not interfere with or disrupt the Platform's operation
          <br />• Not use the Platform to transmit harmful, offensive, or illegal content
          <br />• Not violate any applicable laws or regulations
          <br />• Respect the intellectual property rights of Smrt Stats and third parties
        </p>

        <h2>6. STATISTICAL DATA AND VIDEO CONTENT</h2>
        <h3>6.1. Statistical Information</h3>
        <p>
          Smrt Stats provides football statistical information through our web portal, API service, and XML downloads. This data is provided for informational purposes and we make no warranties regarding its accuracy or completeness.
        </p>

        <h3>6.2. Video Content</h3>
        <p>
          Smrt Stats may provide video recordings to complement statistical data. Video content is licensed to you for viewing purposes only and may not be downloaded, redistributed, or used for commercial purposes without express written permission. Sharing a playlist link created through your plan with the people you work with, as your plan's terms allow, is permitted.
        </p>

        <h3>6.3. API Usage</h3>
        <p>
          If you access our API service, you agree to use it in accordance with our API documentation and rate limits. Abuse of the API service may result in suspension of access. Use of StatsConnect is also subject to the <a href="/connect/terms">StatsConnect Terms</a> at https://smrtstats.com/connect/terms.
        </p>

        <h2>7. USER ACCOUNTS</h2>
        <h3>7.1. Account Creation</h3>
        <p>
          To access certain features you need an account. Some accounts are created by Smrt Stats on request; StatsConnect accounts can be created on our website. You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account.
        </p>

        <h3>7.2. Account Information</h3>
        <p>
          You agree to provide accurate and complete information when creating your account and to update this information as necessary to keep it current.
        </p>

        <h2>8. DISCLAIMER OF WARRANTIES AND LIMITATION OF LIABILITY</h2>
        <p>
          THE SMRT STATS PLATFORM AND ALL INFORMATION, CONTENT, MATERIALS, AND SERVICES INCLUDED ON OR OTHERWISE MADE AVAILABLE TO YOU THROUGH THE PLATFORM ARE PROVIDED BY SMRT STATS ON AN "AS IS" AND "AS AVAILABLE" BASIS. SMRT STATS MAKES NO REPRESENTATIONS OR WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED, AS TO THE OPERATION OF THE PLATFORM OR THE INFORMATION, CONTENT, MATERIALS, OR SERVICES INCLUDED ON OR OTHERWISE MADE AVAILABLE TO YOU THROUGH THE PLATFORM.
        </p>
        <p>
          TO THE FULLEST EXTENT PERMISSIBLE BY APPLICABLE LAW, SMRT STATS DISCLAIMS ALL WARRANTIES, EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO, IMPLIED WARRANTIES OF MERCHANTABILITY, NON-INFRINGEMENT AND FITNESS FOR A PARTICULAR PURPOSE.
        </p>
        <p>
          Nothing in these Terms limits liability that cannot be limited by law, including for death or personal injury caused by negligence, for fraud, or a consumer's statutory rights.
        </p>
        <p>
          Subject to the paragraph above, Smrt Stats is not liable for loss of profits, revenue, business, contracts or opportunity; for decisions you take based on information, content, materials or services made available through the Platform; or for indirect or consequential loss. For consumers, this does not exclude loss that was reasonably foreseeable when the contract was made.
        </p>
        <p>
          Subject to the first paragraph above, Smrt Stats' total liability arising out of or in connection with the Smrt Stats Platform in any 12-month period is limited to the greater of the amount you paid Smrt Stats for the Platform in that period and €100.
        </p>
        <p>
          For information about how we collect, use, and protect your personal data in compliance with GDPR and other data protection regulations, please refer to our <a href="/privacy">Privacy Policy</a>.
        </p>

        <h2>9. APPLICABLE LAW</h2>
        <p>
          By visiting the Smrt Stats Platform, you agree that the laws of Ireland, without regard to principles of conflict of laws, will govern these Terms and any dispute of any sort that may arise between you and Smrt Stats.
        </p>

        <h2>10. DISPUTES</h2>
        <p>
          Any dispute relating in any way to your visit to the Smrt Stats Platform or to services provided by Smrt Stats shall be adjudicated exclusively in the courts of Ireland, and each party agrees not to contest the jurisdiction of these courts. If you are a consumer, you may also bring proceedings in the courts of the country where you live, and you keep the protection of the mandatory laws of that country.
        </p>

        <h2>11. MODIFICATION, SEVERABILITY, WAIVER, ASSIGNMENT, AND ENTIRE AGREEMENT</h2>
        <h3>11.1. Modifications</h3>
        <p>
          Smrt Stats reserves the right to make changes to the Smrt Stats Platform, policies, and these Terms at any time. By continuing to use or access the Platform after these Terms have changed, you indicate your agreement to the revised Terms. For paid services, we give at least 30 days' notice of material changes by email, and you may cancel before they take effect.
        </p>

        <h3>11.2. Severability</h3>
        <p>
          Should any provision of these Terms be found unenforceable, wherever possible this will not affect any other provision, and each will remain in full force and effect.
        </p>

        <h3>11.3. Assignment</h3>
        <p>
          Smrt Stats may assign, transfer, or delegate these Terms or any right or obligation hereunder in its sole discretion. You may not assign, transfer, or delegate these Terms without Smrt Stats' prior written consent.
        </p>

        <h3>11.4. Entire Agreement</h3>
        <p>
          These Terms, Smrt Stats' Privacy Policy, and any other agreement between you and Smrt Stats constitute the sole and entire agreement between you and Smrt Stats regarding the Platform and supersede all prior and contemporaneous understandings, agreements, representations, and warranties regarding the Platform.
        </p>

        <h2>12. OPERATOR</h2>
        <p>
          This website is operated by Smrt Football Limited, with a business address of 3 Charlotte, Honeypark, Dun Laoghaire, Co. Dublin, A96 YF6A, Ireland. Company Number: 739570.
        </p>
        <p>
          For questions or concerns regarding these Terms, please contact us at <a href="mailto:contact@smrtstats.com">contact@smrtstats.com</a>.
        </p>
        <p>
          Last Updated: 12.10.2026
        </p>
      </TermContent>
    </TermsWrapper>
  );
};

export default Terms;
